import React from "react";
import Background from "./Background";
import Suggestion from "./Suggestion";
import { Row, Col } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";

function MaboutMe({rootData}) {
  let history = useHistory();
  const getDetailCard = (view) => {
    history.push(`/posts#${view}`);
  };
  return (
    <>
      <div className="px-3">
        {rootData.educationData?.length > 0 ||
        rootData.workData?.length > 0 ||
        rootData.certificatedata?.length > 0 ||
        rootData.projectdata?.length > 0 ||
        rootData.extraCurdata?.length > 0 ||
        rootData.publicationdata?.length > 0 ? (
          <Background className="mb-4" data={rootData} />
        ) : (
          ""
        )}
      </div>
      <div className="container-fluid mb-16">
        <Row>
          <Col md={6} xs={6}>
            <div
              onClick={() => getDetailCard("blogs")}
              className="blogCount w-full py-4 text-center border shadow rounded bg-white cursor-pointer no-underline"
            >
              <span className="block text-5xl mb-2 text-black manpro font-semibold">
                {rootData.blogCount}
              </span>
              <span className="block text-xl text-black manpro font-medium">
                Blogs
              </span>
            </div>
          </Col>
          <Col md={6} xs={6}>
            <div
              onClick={() => getDetailCard("questions")}
              className="questionCount w-full py-4 text-center border shadow rounded bg-white cursor-pointer no-underline"
            >
              <span className="block text-5xl mb-2 text-black manpro font-semibold">
                {rootData.questionCount}
              </span>
              <span className="block text-xl text-black manpro font-medium">
                Questions
              </span>
            </div>
          </Col>
        </Row>
      </div>
      <div className="">
        <Suggestion className="my-4" isMobile />
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
    return state;
  };
export default connect(mapStateToProps, null)(MaboutMe);
